module.exports = "<ng-container [@fadeAnimation]=\"rows$.length\">\n    <ng-container  *ngFor=\"let row of rows$\">\n        <div class=\"row-animatable\">\n            <row-container *ngIf=\"row | meta\" [row$]=\"row\" class=\"row-container {{(row|meta).obj_type | kebab}}\"></row-container>\n        </div>\n    </ng-container>\n</ng-container>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/rows/rows.template.html
// module id = 692
// module chunks = 2